export default __webpack_public_path__ + "static/media/Resume_Kanhaiya_kumar.1b21dfd1.pdf";